export function clampQuantity(min: number, max: number, value: number): number {
    if (isNaN(value)) {
        return min;
    }
    return Math.max(min, Math.min(max, value));
}
